import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { Link } from "react-router-dom";

interface PrinterHeaderProps {
  onSetupPrinters: () => void;
  warningMessage?: string;
}

const PrinterHeader: React.FC<PrinterHeaderProps> = ({
  onSetupPrinters,
  warningMessage,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4">
      {/* Title */}
      <div className="mb-4">
        <h1 className="text-2xl font-semibold">
          {t("back.management.printer.title")}
        </h1>
        <p className="text-lg font-bold">
          {t("back.management.printer.subtitle")}
        </p>
      </div>

      {/* Buttons */}
      <div className="mb-4 flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0">
        <Link
          to="/printer/setup-print"
          className="w-full rounded-md bg-black px-4 py-2 font-bold text-white shadow hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 sm:w-auto"
        >
          {t("back.management.printer.learnHowToSetUp")}
        </Link>
        <div className="relative w-full sm:w-auto">
          <button
            onClick={onSetupPrinters}
            className="w-full rounded-md bg-red-500 px-4 py-2 font-bold text-white shadow hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 sm:w-auto"
            data-tooltip-id="setup-printer-tooltip"
            data-tooltip-content={warningMessage}
          >
            {t("back.management.printer.setUpPrinters")}
            {warningMessage && (
              <FontAwesomeIcon icon={faInfoCircle} className="ml-2" />
            )}
          </button>
          {warningMessage && <Tooltip id="setup-printer-tooltip" />}
        </div>
      </div>
    </div>
  );
};

export default PrinterHeader;
